import React from "react";
import HeroSection from "./Header";
import Features from "./Features";
import FAQ from "./FAQ";
import Contact from "./Contact";
// import ContactLine from "./ContactLine";
import Footer from "./Footer";
import AboutUs from "./AboutUs";
import Services from "./Services";
import PricingSection from "./Pricing";
import FAQDetailed from "./FaqDetailed";
import Benefits from "./Benefits";
import Testimonials from "./Testimonials";

const Home = () => {
  return (
    <div id="#">
      <HeroSection />
      <AboutUs />
      <Services />
      {/* <ContactLine /> */}
      <Features />
      <Benefits />
      <Testimonials />
      <PricingSection />

      {/* <FAQDetailed /> */}
      <FAQ />
      <Contact />
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/919140753963"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition duration-300 z-50"
        title="Chat on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.117.553 4.168 1.6 6.014L0 24l6.234-1.583A11.942 11.942 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm5.802 17.198c-.263.741-1.543 1.389-2.119 1.473-.567.083-1.284.118-2.073-.135-.479-.154-1.096-.354-1.894-.698-3.314-1.434-5.483-4.95-5.653-5.179-.167-.23-1.35-1.794-1.35-3.428s.85-2.438 1.155-2.778c.304-.341.659-.426.88-.426.22 0 .44.002.632.012.204.012.479-.078.752.574.282.667.957 2.3 1.042 2.466.087.167.146.367.027.598-.118.23-.176.368-.341.567-.167.197-.354.44-.505.591-.167.146-.341.304-.146.596.197.293.876 1.446 1.879 2.34 1.294 1.155 2.388 1.514 2.681 1.682.293.167.459.146.63-.087.167-.23.734-.859.93-1.155.196-.293.391-.243.65-.146.257.097 1.616.763 1.89.901.272.134.455.196.523.304.067.109.067.629-.197 1.37z" />
        </svg>
      </a>
    </div>
  );
};

export default Home;

{
  /* <AboutUs/>
  
   
   <Benefits/>
   <Testimonials/>
   <PricingSection/>
   
   <Contact/> */
}

// import AboutUs from './AboutUs'
// import Benefits from './Benefits'
// import Testimonials from './Testimonials'
// import PricingSection from './Pricing'
// import Services from './Services'
